/* SDS-04: keep the price shown on highlighted option buttons in step with the other
   selected options. Markup: snippets/sds-option-label.liquid. Runs after theme.js (defer). */
(function () {
  function money(cents) {
    var format = window.theme && theme.settings && theme.settings.moneyFormat;
    if (window.theme && theme.Currency && theme.Currency.formatMoney && format) {
      return theme.Currency.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function selectedOptions(container) {
    var selected = {};
    container.querySelectorAll('.variant-input-wrap').forEach(function (wrap) {
      var checked = wrap.querySelector('input[type=radio]:checked');
      var position = (wrap.dataset.index || '').replace('option', '');
      if (checked && position) selected[position] = checked.value;
    });
    container.querySelectorAll('select[data-index]').forEach(function (select) {
      var position = (select.dataset.index || '').replace('option', '');
      if (position) selected[position] = select.value;
    });
    return selected;
  }

  function update(container) {
    var prices = container.querySelectorAll('[data-sds-option-price]');
    var json = container.querySelector('[data-variant-json]');
    if (!prices.length || !json) return;
    var variants;
    try {
      variants = JSON.parse(json.value || json.textContent);
    } catch (e) {
      return;
    }
    var selected = selectedOptions(container);
    prices.forEach(function (el) {
      var wanted = Object.assign({}, selected);
      wanted[el.dataset.optionPosition] = el.dataset.optionValue;
      var match = variants.find(function (v) {
        return Object.keys(wanted).every(function (pos) {
          return v['option' + pos] === wanted[pos];
        });
      });
      if (match) el.innerHTML = money(match.price);
    });
  }

  function updateAll() {
    document.querySelectorAll('[data-variant-json]').forEach(function (json) {
      var container = json.closest('[data-section-id]') || json.closest('form') || document;
      update(container);
    });
  }

  document.addEventListener('variant:change', updateAll);
  document.addEventListener('quickview:loaded', updateAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
